import { render } from "./PixParcelado.vue?vue&type=template&id=3e4334b7&scoped=true"
import script from "./PixParcelado.vue?vue&type=script&lang=js"
export * from "./PixParcelado.vue?vue&type=script&lang=js"

import "./PixParcelado.vue?vue&type=style&index=0&id=3e4334b7&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4334b7"]])

export default __exports__